
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-provider-cognito-identity";

import { S3Client, PutObjectCommand, ListObjectsCommand, DeleteObjectCommand, DeleteObjectsCommand } from "@aws-sdk/client-s3";
import { Upload } from "@aws-sdk/lib-storage";

// Set the AWS Region
const REGION = window.AWS_REGION || 'us-west-1'; //REGION
const POOL_ID = window.AWS_POOL_ID || 'us-west-1:aa7c5d24-038f-4ee6-8b18-18797513a0dd';
const BUCKET_NAME = window.AWS_BUCKET || "homestead-entertainment"; //BUCKET_NAME
import Alpine from 'alpinejs';

export default class AWS {
    constructor() {
        this.s3 = new S3Client({
            region: REGION,
            credentials: fromCognitoIdentityPool({
                client: new CognitoIdentityClient({ region: REGION }),
                identityPoolId: POOL_ID,
            }),
        });
    }

    async ls(path) {
        const data = await this.s3.send(
            new ListObjectsCommand({ Delimiter: path || "/", Bucket: BUCKET_NAME })
        );

        return data;
    }
    async blobToBase64(blob) {
        return new Promise((resolve, _) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
        });
    }

    async update_cover_image(s3_file_id, blob) {
        let b64 = await this.blobToBase64(blob);
        b64 = b64.toString();

        let url = `/listings/update_cover_image?s3_file_id=${s3_file_id}`

        return await fetch(url, {
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            method: 'POST',
            body: JSON.stringify({cover_image_blob: b64})
        })
    }

    async create_attached_s3_file(content_id, f) {
        let url = `/listings/create_attached_s3_file`
        let payload = { s3_file: JSON.stringify({ content_id: content_id, id: f.id, path: f.path, filesize: f.filesize, filename: f.filename, type: f.type }) };
        let data = await $.post(url, payload)
        console.log('[aws] create_associated_s3_file: finished', data);
        return data;
    }

    async create_s3_file(f) {
        let url = `/listings/create_s3_file`
        let payload = { s3_file: JSON.stringify({ id: f.id, path: f.path, filesize: f.filesize, filename: f.filename, type: f.type }) };
        let data = await $.post(url, payload)
        console.log('[aws] create_s3_file: finished', data);
        return data;
    }

    async video_puts(file, opts) {
        console.log(`[aws] uploading to ${file.path}`, file);
        let params = {
            Bucket: BUCKET_NAME,
            Key: file.path,
            Body: file.file || file,
            partSize: 5,
            queueSize: 1
        };
        let res;
        let success;

        const parallelUploads3 = new Upload({
            client: this.s3,
            params,
        });

        console.log('[aws] PUTS: attaching upload events to callback')
        parallelUploads3.on('httpUploadProgress', (progress)=>{
            opts.progress(progress);
        });


        success = await parallelUploads3.done();

        if (opts.finish) {
            await opts.finish(success)
        }

        console.log('[aws] upload complete', res);
    }

    async puts(file, opts = {}) {
        console.log(`[aws] uploading to ${file.path}`, file);
        let params = { Bucket: BUCKET_NAME, Key: file.path, Body: file.file || file };
        let res;
        let success;

        try {
            const parallelUploads3 = new Upload({
                client: this.s3,
                params,
            });

            if (opts && opts.progress) {
                console.log('[aws] PUTS: attaching upload events to callback')
                parallelUploads3.on('httpUploadProgress', (progress)=>{
                    console.debug('CUSTOM PROGRESS', file.filename, file.progress);
                    opts.progress(progress);
                });

            } else {
                parallelUploads3.on("httpUploadProgress", (progress) => {
                    console.debug('PROGRESS', file.filename, file.progress);
                    file.progress = parseInt(parseFloat(progress.loaded) / progress.total) * 100
                    file.progress_total = progress.total
                    file.progress_loaded = progress.loaded
                    Alpine.store('media').updateFile(file);
                });
            }

            success = await parallelUploads3.done();
        } catch (e) {
            console.log(e);
            success = false
            if (opts.failed) {
                opts.failed(e)
            }
        }

        if (opts && opts.finish && success) {
            opts.finish(success)
        }

        console.log('[aws] upload complete', res);

        try {
            file.status = "Processing";
            file.css_status = "processing";
            Alpine.store('media').updateFile(file);

            let s3_results = await this.create_s3_file(file);

            file.status = "Uploaded";
            file.css_status = "done";

            if (s3_results && s3_results.s3_file_id) {
                file.s3_file_id = s3_results.s3_file_id;
                file.s3_url = s3_results.s3_url;
                console.log('[aws] setting s3_file_id = ', file.s3_file_id, file)
                Alpine.store('media').updateFile(file);
            } else {
                console.error(`[aws] failed to attached s3 file`, s3_results)
            }


        } catch (e) {
            console.error(e);
            file.status = "Failed";
            file.css_status = "error";
            Alpine.store('media').updateFile(file);
        }

        return res;
    }

}

export const Instance = new AWS();
window.AWS = Instance;
